import { logger } from "@justhome/common";
import { Component, PropsWithChildren } from "react";

export default class ErrorBoundary extends Component<PropsWithChildren> {
  componentDidCatch(error: Error) {
    logger.error("Unhandled error", error);
  }

  render() {
    return this.props.children;
  }
}
